export default "__VITE_ASSET__CLVvGPCj__"